<template>
  <v-container fluid class="fluidicin" grid-list-xs>
    <v-card color="grey lighten-2" flat>
      <v-layout row wrap>
        <v-toolbar  style="height: 48px; align-items: baseline;"  size="120px"  dark color="orange darken-4">
          <v-toolbar-title  class="baslikfont">{{saticiTipi}} Listesi</v-toolbar-title>

          <v-spacer></v-spacer>
          <a target="_self" v-bind:href="'#/Coper/saticitanit/0/'+saticiTipi">
            <v-btn flat> {{saticiTipi}} Ekle
              <v-icon right dark>add_circle_outline</v-icon>
            </v-btn>
          </a>
          <v-btn color="info" @click="CSVIndir()">csv İndir</v-btn>

        </v-toolbar>
        <v-container fluid class="fluidicin">
          <v-card color="grey lighten-1">
            <v-layout row wrap>
              <v-flex xs12 sm2 >
               <v-select
                
                hide-details
                :items="saticiTipleri" label="Satici Tipi Seçiniz"
                item-text="text"
                item-value="id"
                v-model="saticiTipi" ></v-select>
              </v-flex>
              
              <v-flex xs12 sm4 >
                <v-text-field hide-details label="Satıcı Arama... (En az 3 harf giriniz)" append-icon="search" v-model="Query.q" ></v-text-field>
              </v-flex>
              <v-flex xs12 sm1 class="flexortala-buton">
                <div v-if="progress">
                  <v-progress-circular indeterminate color="primary"></v-progress-circular>
                </div>
                  <div v-if="progress1">
                   <a target="_self" v-bind:href="'#/coper/saticitumkayitlar/'+ saticiTipi">
                      <v-btn class="custombuton" color="info">Tüm {{saticiTipi}} Göster</v-btn>
                </a>
                </div>

              </v-flex>
               <v-flex xs12 sm1 class="flexortala">

              </v-flex>
              <v-flex xs12 sm5 class="flexortala">
              </v-flex>


            </v-layout>
          </v-card>
        </v-container>
        <template>
          <v-container fluid class="fluidicin" >
            <v-layout row wrap>
                <div v-show="kayitlar" class="flex xs12 sm12 xs12">
              <div class="card card--tile " style="height: 50px;">
                <div class="card__text grey darken-1 white--text">
                  <h3>toplam {{toplamkayit}} kayıt listelendi.</h3>
                </div>
              </div>
          </div>
              <v-flex class="deneme" xs12 sm6 v-for="satici in Saticilar" :key="satici.Kod">
                <v-card>
                  <a target="_self" :title="satici.Kod" v-bind:href="'#/Coper/saticitanit/'+satici.Kod+'/'+saticiTipi ">
                    <v-card-title class="orange darken-4">
                      <span class="card_baslik">{{satici.Isim}}</span>
                    </v-card-title>
                    <v-list two-line>
                      <v-list-tile>
                        <v-list-tile-action>
                          <v-icon>business</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                          <v-list-tile-title>{{ satici.Kod }}</v-list-tile-title>
                        </v-list-tile-content>
                        <v-list-tile-action>
                        </v-list-tile-action>
                      </v-list-tile>


                      <v-divider inset></v-divider>
                      <v-list-tile>
                        <v-list-tile-action>
                          <v-icon>fingerprint</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                          <v-list-tile-title>{{ satici.Cari_Kod }}</v-list-tile-title>
                        </v-list-tile-content>
                        <v-list-tile-action>
                        </v-list-tile-action>
                      </v-list-tile>

                      <v-divider inset></v-divider>
                      <v-list-tile>
                        <v-list-tile-action>
                          <v-icon>phone</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                          <v-list-tile-title>{{ satici.Tel1 }}</v-list-tile-title>
                        </v-list-tile-content>
                        <v-list-tile-action>
                        </v-list-tile-action>
                      </v-list-tile>
                      
                      
                      <v-divider inset></v-divider>
                      <v-list-tile>
                        <v-list-tile-action>
                          <v-icon>mail</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                          <v-list-tile-title>{{ satici.Email }}</v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-divider inset></v-divider>
                      <v-list-tile>
                        <v-list-tile-action>
                          <v-icon>location_on</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                          <v-list-tile-title>{{ satici.Adres }}</v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                    </v-list>
                  </a>
                </v-card>
              </v-flex>
            </v-layout>
            <v-spacer></v-spacer>
          </v-container>

        </template>
      </v-layout>
    </v-card>
     <template>
      <v-card>
        <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'" :left="x === 'left'" :multi-line="mode === 'multi-line'"
          :vertical="mode === 'vertical'" v-model="snackbar">
          {{ text1 }}
          <v-btn flat color="pink" @click.native="snackbar = false">Kapat</v-btn>
        </v-snackbar>
      </v-card>
    </template>
  </v-container>

</template>
<script>
  import auth from '../../../../../api/auth'
  export default {
    data() {
      return {
        loading: false,
        items: [],
        search: null,
        Saticilar: [],
        progress: false,
        progress1: true,
        saticiTipleri: [

        {id:'Otel', text:'Otel'},
        {id:'Arac', text:'Araç'},
        {id:'Restaurant', text:'Restaurant'},
        {id:'Acente', text:'Acente'},
        {id:'RentACar', text:'Ren A Car'},
        {id:'Rehber', text:'Rehber'},
        {id:'Muze', text:'Müze'},
        {id:'Charter', text:'Charter'},
        {id:'Gemi', text:'Gemi'},
        {id:'Diger', text:'Diğer'},
        {id:'TurOperatoru', text:'Tur Operatoru'},
        {id:'Konsolosluk', text:'Konsolosluk'},
        {id:'Sigorta', text:'Sigorta'},
        {id:'Feribot', text:'Feribot'},
        {id:'Golf', text:'Golf'},

        ],
        saticiTipi:"Otel",

        kayit: false,
        toplamkayit:'',
        kayitlar: false,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text1: '',
        Query: {
          q: '',
          cari: ''
        }
      }
    },
    watch: {
      'Query.q': getCurrents
    },
    methods: {
      getCurrents: getCurrents,
      CSVIndir:CSVIndir,
      downloadFile : downloadFile

    }
  }

  function getCurrents(e) {
    if (e.length >= 3) {
      this.progress = true
     this.progress1 = false

     var prm ={saticiTipi:this.saticiTipi,saticiKodu:"",sqlLike:e,limit:0 }

      this.$http.post(auth.API_URL + 'api/Coper/SaticiList', prm, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        console.log(response.body);
        
        this.Saticilar = response.body
        this.toplamkayit= response.body.length
        this.kayit = false
        this.kayitlar= true
        this.progress = false
        this.progress1 = true
      }, (response) => {
        if (response.status === 0) {
          this.progress = false
          this.progress1 = true
          this.text1 = 'Service Unavailable'
          this.snackbar = true
        } else {
           this.Saticilar = []
          this.kayit = true
          this.Error = response.statusText
        }
      })
    } else if (e.length === 0) {
      this.kayit = true
      this.kayitlar=false

      this.progress = false
      this.Saticilar = []
    } else {
       this.text1 = 'Service Unavailable'
       this.kayitlar=false

      this.progress = false
      this.Saticilar = []


    }
  }

  function CSVIndir() {

    var win = window.open('_blank');
        downloadFile(auth.API_URL +'api/Coper/ExportCsvData', function(File) {
            var url = URL.createObjectURL(File);
            win.location = url;
        });


  }



function downloadFile(url, success) {
        var xhr = new XMLHttpRequest();
        xhr.open('GET', url, true);
        xhr.setRequestHeader('Authorization', 'Bearer ' + auth.getAuthHeader());
        xhr.responseType = "text/csv";
        xhr.onreadystatechange = function() {
            if (xhr.readyState == 4) {
                if (success) success(xhr.response);
            }
        };
        xhr.send(null);
    }



</script>


